import { styled } from "styled-components";

interface DividerProps {
  orientation?: "horizontal" | "vertical";
  children?: React.ReactNode;
}

const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border};
  margin: 16px 0;
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.border};
  margin: 0 16px;
`;

const DividerWithText = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 16px 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.border};
  }
`;

const DividerText = styled.span`
  padding: 0 16px;
  color: ${({ theme }) => theme.colors.grey};
  font-size: 14px;
`;

export const Divider = ({ orientation = "horizontal", children }: DividerProps) => {
  if (children) {
    return (
      <DividerWithText>
        <DividerText>{children}</DividerText>
      </DividerWithText>
    );
  }

  if (orientation === "vertical") {
    return <VerticalDivider />;
  }

  return <HorizontalDivider />;
};
